import { useQuery } from "@apollo/client";
import { GET_WORKING_DAY } from "../../Queries";

export default (props) => {
  const { data, refetch, loading, error } = useQuery(GET_WORKING_DAY, {
    ...props,
  });
  return { data: data?.getWorkingDay, loading, refetch, error };
};
